import { executeUI } from '@common/utils/ui-bridge';

export const createBatchLetters = (globalIds) => {
  executeUI('LETTERS', 'batchLetters', globalIds.join(','));
};